/* eslint-disable react/display-name */
/* eslint-disable import/no-anonymous-default-export */
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

import cls from 'classnames';
import { Autoplay } from 'swiper';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';
import TPLink from '@/components/TPLink';

// import useIsMobile from '@/hooks/useIsMobile';
import 'swiper/css';
import 'swiper/css/pagination';

export default () => {
  const { t, i18n } = useTranslation(['home', 'english', 'common']);
  //   const isMobile = useIsMobile();
  const swiperRef = useRef<SwiperRef['swiper']>();
  const studens = {
    zh: [
      {
        name: 'Ben',
        country: '新西兰',
        age: '8岁',
        level: '高级阅读写作E2',
        flag: '/images/english/countrys/nz.svg',
        stu: 1,
        marks: '/images/english/students/icon_1.svg',
        avatarXl: '/images/english/students/stu_2_1920.png',
        avatarLg: '/images/english/students/stu_2_1024.png',
        avatarSm: '/images/english/students/stu_2_375.png',
        feedback:
          '"老师上课的时候非常幽默风趣，在她生动的讲解下，我知道了优秀的文章具体好在哪儿，要如何才能写出跟它一样好的作品。现在阅读和写作能力都在不知不觉中提高了很多！"',
      },
      {
        name: 'Anna',
        country: '美国',
        age: '9岁',
        level: '高级阅读写作E3',
        stu: 2,
        flag: '/images/english/countrys/us.svg',
        marks: '/images/english/students/icon_3.svg',
        avatarXl: '/images/english/students/stu_3_1920.png',
        avatarLg: '/images/english/students/stu_3_1024.png',
        avatarSm: '/images/english/students/stu_3_375.png',
        feedback:
          '"悟空ELA课程不仅提高了我的阅读水平，还教给了我很多写作技巧。老师总是很有趣，我喜欢和同学们一起分享我们写的故事，这让学习变得更有意思。"',
      },
      {
        name: 'Sophie',
        country: '澳大利亚',
        flag: '/images/english/countrys/au.svg',
        age: '10岁',
        marks: '/images/english/students/icon_2.svg',
        stu: 3,
        level: '高级阅读写作E4',
        avatarXl: '/images/english/students/stu_1_1920.png',
        avatarLg: '/images/english/students/stu_1_1024.png',
        avatarSm: '/images/english/students/stu_1_375.png',
        feedback:
          '"我学到了许多有趣的阅读和写作思路，老师总是鼓励我们表达自己的想法。现在我写作更有条理，也更愿意尝试不同的文学风格。真的很感谢老师的帮助！"',
      },
    ],
    en: [
      {
        name: 'Ben',
        country: 'New Zealand',
        flag: '/images/english/countrys/nz.svg',
        age: '8 years old',
        stu: 1,
        marks: '/images/english/students/icon_1.svg',
        level: 'excelling in Advanced Reading & Writing E2',
        avatarXl: '/images/english/students/stu_2_1920.png',
        avatarLg: '/images/english/students/stu_2_1024.png',
        avatarSm: '/images/english/students/stu_2_375.png',
        feedback: `"WuKong's classes are so good! I get to read all these cool stories and articles that are super interesting. Because of these classes, every time I start writing, all these awesome ideas pop into my head, and I can't wait to jot them down."`,
      },
      {
        name: 'Anna',
        country: 'USA',
        age: '9 years old',
        stu: 2,
        level: 'thriving in Advanced Reading & Writing E3',
        flag: '/images/english/countrys/us.svg',
        marks: '/images/english/students/icon_3.svg',
        avatarXl: '/images/english/students/stu_3_1920.png',
        avatarLg: '/images/english/students/stu_3_1024.png',
        avatarSm: '/images/english/students/stu_3_375.png',
        feedback: `"I really like how the course has made reading so much fun for me. I've learned cool writing tricks that make my stories better. The teachers are super fun, and it's awesome to share my stories with my friends in class."`,
      },
      {
        name: 'Sophie',
        country: 'Australia',
        age: '10 years old',
        stu: 3,
        marks: '/images/english/students/icon_2.svg',
        flag: '/images/english/countrys/au.svg',
        level: 'excelling in Advanced Reading & Writing E4',
        avatarXl: '/images/english/students/stu_1_1920.png',
        avatarLg: '/images/english/students/stu_1_1024.png',
        avatarSm: '/images/english/students/stu_1_375.png',
        feedback: `"In WuKong's classes, I've picked up some better ways to read and write. The teachers are great at helping us say what we're thinking. My writing's gotten so much clearer, and I love trying out different ways to tell stories now. I'm super thankful for all the help from my teachers!"`,
      },
    ],
  };

  return (
    <div className="mx-auto mt-[5rem] lg:mt-[140px] xl:mt-[200px] xl:w-[1440px]">
      <div className="flex justify-center">
        <Title innerHTML theme="english" className="relative hidden lg:inline xl:inline xl:tracking-[0.96px]">
          {`${t('english:ela-标题', { tag: '' })}<div class="absolute right-[-100px] top-[-45px] hidden h-[80px] w-[80px] shrink-0 rotate-[-15deg] items-center justify-center rounded-[20px] bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] shadow-[0px_33px_50px_0px_rgba(0,0,0,0.06)] lg:flex xl:flex">
          <img class="w-[49px]" src="/images/english/heart.png" alt="" />
          <img class="absolute right-[-30px] top-[20px] w-[39px]" src="/images/english/rectangle.png" alt="" />
        </div>`}
        </Title>
      </div>
      <Title innerHTML theme="english" className="lg:hidden xl:hidden xl:tracking-[0.96px]">
        {t('english:ela-标题', { tag: '<br/>' })}
      </Title>
      <TPLink>
        <p className="mb-6 mt-6 flex items-center justify-center text-xs lg:mt-5 lg:justify-center  lg:text-sm xl:mt-[22px] xl:text-xl">
          <span className="mr-2">Trustpilot</span>
          <span className="h-[14px] w-[81px] lg:h-4 lg:w-[92px] xl:h-[20px] xl:w-[115px]">
            <Image alt="WuKong userReviews" width={115} height={20} src="/images/home/userReviews-tp2.jpg" />
          </span>
          <span className="ml-2" dangerouslySetInnerHTML={{ __html: t('home:banner-tp-1') }} />
        </p>
      </TPLink>

      <div className="mx-auto hidden lg:block lg:w-[984px] xl:mb-[60px] xl:mt-[60px] xl:block xl:w-[1440px]">
        <Swiper
          className="absolute !p-[20px]"
          slidesPerView="auto"
          centeredSlides
          spaceBetween={20}
          loop
          onInit={(swiper: SwiperRef['swiper']) => {
            swiperRef.current = swiper;
            swiper.el.addEventListener('mouseenter', () => {
              swiper.autoplay?.stop();
            });
            swiper.el.addEventListener('mouseleave', () => {
              swiper.autoplay?.start();
            });
          }}
          modules={[Autoplay]}
          speed={1000}
          autoplay
        >
          {studens[i18n.language as keyof typeof studens]?.map((student, index) => {
            return (
              <SwiperSlide
                key={index}
                className="rounded-[36px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:!h-[310px] lg:!w-[600px] xl:!h-[360px] xl:!w-[720px]"
              >
                <div className="relative flex lg:p-[32px] xl:p-[40px]">
                  <Image
                    className="absolute lg:top-[-20px] lg:w-[40px] xl:left-[40] xl:top-[-25px] xl:w-[48px]"
                    src={student.marks}
                    alt=""
                    loading="lazy"
                    width={32}
                    height={32}
                  />
                  <Image
                    className="mr-[24px] hidden lg:h-[234px] lg:w-[200px] lg:rounded-[16.667px] xl:block xl:h-[280px] xl:w-[240px] xl:rounded-[20px]"
                    src={student.avatarXl}
                    alt={t('english:seo-悟空高级英文阅读与写作学生')}
                    loading="lazy"
                    width={280}
                    height={234}
                  />
                  <Image
                    className="mr-[24px] hidden lg:block lg:h-[234px] lg:w-[200px] lg:rounded-[16.667px] xl:hidden xl:h-[280px] xl:w-[240px] xl:rounded-[20px]"
                    src={student.avatarLg}
                    alt={t('english:seo-悟空高级英文阅读与写作学生')}
                    loading="lazy"
                    width={240}
                    height={280}
                  />
                  <div>
                    <h3 className="flex items-center lg:mb-[8px] xl:mb-[16px] ">
                      <span className="font-extrabold lg:text-[20px] lg:font-semibold xl:text-[24px] xl:text-wk-words-1">
                        {student.name}
                      </span>
                      <span className="ml-[8px] mr-[8px] h-[14px] w-[1px] border-r-[1px] border-[#8D8FA6]" />
                      <span className="flex shrink-0">
                        {student.country} <img className="ml-[4px]" src={student.flag} alt="" />
                      </span>
                      <span className="ml-[8px] mr-[8px] h-[14px] w-[1px] border-r-[1px] border-[#8D8FA6]" />
                      <span>{student.age}</span>
                    </h3>
                    <h3 className="flex items-center text-[16px] font-normal lg:mb-[12px] xl:mb-[24px] xl:text-wk-words-2">
                      <span>
                        <b className="mr-[4px]">•</b>
                        {student.level}
                      </span>
                    </h3>
                    <p
                      className={cls(
                        'font-normal text-wk-words-2 lg:text-[16px] lg:leading-[26px] xl:text-[18px] xl:leading-[30px]',
                        i18n.language === 'en' ? 'lg:!leading-[22px] xl:!leading-[26px]' : '',
                      )}
                    >
                      {student.feedback}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
          <div className="absolute left-0 top-0 z-10 h-[400px] w-[350px] bg-gradient-to-r from-[rgba(255,255,255,1)] to-[rgba(255,255,255,0)]" />
          <div className="absolute right-0 top-0 z-10 h-[400px] w-[350px] bg-gradient-to-l from-[rgba(255,255,255,1)] to-[rgba(255,255,255,0)]" />
          <div
            className="prev absolute left-0 top-[162px] z-20 cursor-pointer rounded-[9999px] hover:bg-[#F0F1FC] xl:h-[48px] xl:w-[48px]"
            onClick={() => {
              swiperRef.current?.slidePrev();
            }}
          >
            <Image src="/images/english/prev.svg" width={48} height={48} alt="" loading="lazy" />
          </div>
          <div
            className="next absolute right-0 top-[162px] z-20 cursor-pointer rounded-[9999px] hover:bg-[#F0F1FC] xl:h-[48px] xl:w-[48px]"
            onClick={() => {
              swiperRef.current?.slideNext();
            }}
          >
            <Image src="/images/english/prev.svg" width={48} height={48} className="rotate-180" alt="" loading="lazy" />
          </div>
        </Swiper>
      </div>
      <div />
      <div className="lg:hidden xl:mb-[60px] xl:mt-[60px] xl:hidden">
        <Swiper
          modules={[Autoplay]}
          autoplay
          onInit={(swiper: SwiperRef['swiper']) => {
            swiper.el.addEventListener('touchstart touchmove', () => {
              swiper.autoplay?.stop();
            });
            swiper.el.addEventListener('touchend', () => {
              swiper.autoplay?.start();
            });
          }}
          className="xl:!p-[20px]"
          slidesPerView="auto"
          loop
        >
          {studens[i18n.language as keyof typeof studens]?.map((student, index) => {
            return (
              <SwiperSlide key={index} className="!w-[20rem] pb-[.13rem] xl:!w-[720px] xl:rounded-[36px]">
                <div className="relative mx-5">
                  <div className="overflow-hidden rounded-[1.5rem_1.5rem_0rem_0rem]">
                    <Image
                      src={student.avatarSm}
                      width={375}
                      height={250}
                      alt={t('english:seo-悟空高级英文阅读与写作学生')}
                      loading="lazy"
                    />
                  </div>
                  <div
                    className={`relative bottom-[2em] z-10 ${i18n?.language === 'zh' ? '!h-[19rem]' : '!h-[28rem]'} rounded-3xl bg-white p-[2.25rem_1.5rem_1.5rem_1.5rem] shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)]`}
                  >
                    <Image
                      className="absolute left-[1.25rem] top-[-1.25rem] w-[3rem] xl:left-[40] xl:top-[-25px] xl:w-[48px] "
                      src={student.marks}
                      alt={t('english:seo-悟空高级英文阅读与写作学生')}
                      loading="lazy"
                      width={32}
                      height={32}
                    />
                    <h3 className="flex items-center xl:mb-[16px] xl:text-[24px] xl:text-wk-words-1">
                      <span className="text-2xl/normal font-extrabold text-wk-words-1 lg:text-[20px] lg:font-semibold">
                        {student.name}
                      </span>
                      <span className="ml-[8px] mr-[8px] h-[14px] w-[1px] border-r-[1px] border-[#8D8FA6]" />
                      <span className="flex shrink-0 font-normal text-wk-words-2">
                        {student.country}{' '}
                        <Image className="ml-[4px]" width={16} height={16} src={student.flag} alt="" loading="lazy" />
                      </span>
                    </h3>
                    <h3 className="mt-2 hidden items-center font-normal text-wk-words-2 lg:flex xl:mb-[24px] xl:flex xl:text-[16px]">
                      <span>{student.age}</span>
                      <span className="ml-[8px] mr-[8px] h-[14px] w-[1px] border-r-[1px] border-[#8D8FA6]" />
                      {student.level}
                    </h3>
                    <p className="mt-[0.66rem] text-wk-words-2 lg:hidden xl:hidden">
                      <p className="flex items-start">
                        <span className="mr-1">•</span> {student.age}
                      </p>
                      <p className="flex items-start">
                        <span className="mr-1">•</span> {student.level}
                      </p>
                    </p>
                    <p className="mb-4 mt-4 text-base font-normal text-wk-words-2">{student.feedback}</p>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div />
      <div className="text-center lg:mt-[39px] xl:mt-[60px]">
        <LeadButton
          subject="english"
          theme="english"
          size="xl"
          traceName="O_EnglishCourse_WordOfMouth_CTAClick"
          traceGa4Name="new_entry_EnglishCourse_WordOfMouthCTA"
        >
          {t('english:立即体验')}
        </LeadButton>
      </div>
    </div>
  );
};
